export const OpenConnectCrmModal = (crm) => {
  return {
    type: "OPEN_CONNECT_CRM_MODAL",
    crm: crm,
  };
};
export const CloseConnectCrmModal = () => {
  return {
    type: "CLOSE_CONNECT_CRM_MODAL",
  };
};
